import type * as Types from 'app/types/graphql';

export type VariantWithProductVariantSelectFragment = {
  productVariants?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.VariantProductVariant,
          'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
        >
      >
    >
  >;
};

export type VariantProductVariantSelectFragment = Pick<
  Types.VariantProductVariant,
  'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
>;

export type VariantProductVariantTotalCountSelectFragment = Pick<
  Types.VariantProductVariantConnection,
  'totalCount'
>;

export type VariantProductVariantEdgeSelectFragment = Pick<
  Types.VariantProductVariantEdge,
  'cursor'
> & {
  node?: Types.Maybe<
    Pick<
      Types.VariantProductVariant,
      'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
    >
  >;
};

export const VariantProductVariantSelectFragmentDoc = `
    fragment VariantProductVariantSelect on VariantProductVariant {
  id
  baseID
  name
  price
  compareAtPrice
  variantID
}
    `;
export const VariantWithProductVariantSelectFragmentDoc = `
    fragment VariantWithProductVariantSelect on Variant {
  productVariants {
    ...VariantProductVariantSelect
  }
}
    `;
export const VariantProductVariantTotalCountSelectFragmentDoc = `
    fragment VariantProductVariantTotalCountSelect on VariantProductVariantConnection {
  totalCount
}
    `;
export const VariantProductVariantEdgeSelectFragmentDoc = `
    fragment VariantProductVariantEdgeSelect on VariantProductVariantEdge {
  cursor
  node {
    ...VariantProductVariantSelect
  }
}
    `;
